/* eslint-disable no-restricted-syntax */
// @mui material components
import {
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Card,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  Icon,
  Autocomplete,
  TextField,
  Box,
  // Button,
  // LinearProgress,
  Typography,
  Divider,
  MenuItem,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

import { useEffect, useState, useRef } from "react";
import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

import { useNavigate, useParams } from "react-router-dom";
import { useGeolocated } from "react-geolocated";
import QRCode from "react-qr-code";

import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
import FormSectionBuilder from "app/components/data_forms/form_section_builder";
// import GoogleAddressField from "app/components/google_address";
import WarningIcon from "assets/images/icons/custom/warning.png";

import PushNotificationMgr from "app/components/push_notification_mgr";
import NoSleep from "nosleep.js";
import DataFormComponent from "app/components/data_forms/data_form";

function DataCapturePage() {
  const pageTitle = "Data Capture";
  usePageTitle(pageTitle);
  const { ref, leadRef } = useParams();
  const dataFormRef = useRef();

  // const [controller] = useMaterialUIController();
  // const { darkMode } = controller;

  const navigate = useNavigate();

  function emptyCache() {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }

  function versionRefresh() {
    emptyCache();
    window.location.reload();
  }

  function appVersionCheck(newVersion) {
    // Handle App Update
    const currentVersion = localStorage.getItem(AppConfig.app_version_store);
    let shouldUpdate = false;
    if (currentVersion !== newVersion) {
      shouldUpdate = true;
    }
    localStorage.setItem(AppConfig.app_version_store, newVersion);

    if (shouldUpdate) {
      if (
        window.confirm(
          "A new version is available. App will automatically refresh to get the latest update.",
        ) === true
      ) {
        versionRefresh();
      } else {
        versionRefresh();
      }
    }
  }

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setShowLoading(false);
    setSeverity("error");
  };

  const [dataForm, setDataForm] = useState(null);
  const [loadedCampaign, setLoadedCampaign] = useState(null);
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  const [statusMsg, setStatusMsg] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);

  const [offlineLink, setOfflineLink] = useState(null);

  const [presetAmount, setPresetAmount] = useState(null);
  const [selectedAmount, setAmount] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [sellResult, setSellResult] = useState(null);
  const [showInlineLoading, setShowInlineLoading] = useState(false);

  const noSleep = new NoSleep();
  const [dataFormStartTime, setDataFormStartTime] = useState(null);

  useEffect(() => {
    setDataForm(null);
    setPresetAmount(null);
    setAmount(null);
    setPaymentMethod(null);

    if (loadedCampaign === null) {
      return;
    }

    if (loadedCampaign.data_form === null) {
      setSeverity("error");
      setErrMsg("No data form resource was found.");
      setOpen(true);
      return;
    }

    setDataForm(loadedCampaign.data_form);
    setPresetAmount(loadedCampaign.preset_amount);
    if (loadedCampaign.preset_amount !== null) {
      if (loadedCampaign.preset_amount.amount_type === "FIXED") {
        setAmount(loadedCampaign.preset_amount.amount / 100);
      }
    }
    setPaymentMethod(null);
    setAmount(null);
    setOfflineLink(loadedCampaign.offline);

    setDataFormStartTime(Date.now());

    noSleep.enable();
  }, [loadedCampaign]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/data_capture/campaign/${ref}/init.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            console.log(result.data.data.campaign);
            setLoadedCampaign(result.data.data.campaign);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }

          appVersionCheck(result.data.version);
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }
    return false;
  }

  async function capture() {
    let lat = null;
    let lng = null;
    const gpsCoords = getGPSCoords();
    if (loadedCampaign.enforce_location_capture) {
      if (!gpsCoords) {
        setSeverity("error");
        setErrMsg("Please enable and allow browser's location and GPS access.");
        setOpen(true);
        return;
      }
    }

    // Collect if captured
    if (gpsCoords) {
      lat = gpsCoords.latitude;
      lng = gpsCoords.longitude;
    }

    let dataFormValues = null;
    if (dataForm !== null) {
      const formResult = dataFormRef.current.submit();
      if (formResult.error) {
        setSeverity("error");
        setErrMsg(formResult.error);
        setOpen(true);
        return;
      }
      dataFormValues = formResult.values;
    }

    let pAmount = selectedAmount;
    if (presetAmount !== null) {
      const amt = parseInt(selectedAmount, 10);
      if (presetAmount.amount_type === "VARIABLE") {
        if (presetAmount.minimum_amount) {
          if (amt < presetAmount.minimum_amount / 100) {
            setSeverity("error");
            setErrMsg("Amount cannot be less than the minimum amount.");
            setOpen(true);
            return;
          }
        }

        if (presetAmount.maximum_amount) {
          if (amt > presetAmount.maximum_amount / 100) {
            setSeverity("error");
            setErrMsg("Amount cannot exceed the maximum amount.");
            setOpen(true);
            return;
          }
        }

        pAmount = amt * 100;
      }

      if (paymentMethod === null) {
        setSeverity("error");
        setErrMsg("Payment method is required.");
        setOpen(true);
        return;
      }
    }

    if (window.confirm("Are you sure you want to proceed?") === false) {
      return;
    }

    let fillDuration = null;
    if (dataFormStartTime) {
      fillDuration = Date.now() - dataFormStartTime;
    }

    setShowLoading(true);
    const json = {
      campaign: ref,
      form: dataForm.reference,
      data: dataFormValues,
      latitude: lat,
      longitude: lng,
      amount: pAmount,
      payment_method: paymentMethod,
      fill_duration: fillDuration,
      lead_reference: leadRef,
    };

    // console.log(json);

    await axios
      .post("agents/data_capture/submit.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          console.log(result.data.data);
          if (result.data.data.status === "success") {
            setDataForm(null);
            setDataForm(loadedCampaign.data_form);
            setStatusMsg(result.data.data.message);
            setOpenSuccessDialog(true);
          } else {
            setSellResult(result.data.data);
          }
        } else {
          // setSeverity("error");
          // setErrMsg(result.data.data.message);
          // setOpen(true);

          setStatusMsg(result.data.data.message);
          setOpenErrorDialog(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setStatusMsg("An unexpected error occurred. Please try again later.");
        setOpenErrorDialog(true);
      });
  }

  const [
    allowPushNotificationDialogState,
    setAllowPushNotificationDialogState,
  ] = useState(false);

  async function checkPayment(ref) {
    setShowInlineLoading(true);
    await axios
      .get(`agents/data_capture/${ref}/status.json`)
      .then((result) => {
        setShowInlineLoading(false);
        if (result.data.status === "success") {
          // console.log(result.data.data);
          if (result.data.data.status === "success") {
            setSellResult(null);

            setErrMsg(result.data.data.message);
            setStatusMsg(result.data.data.message);
            setOpenSuccessDialog(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setStatusMsg("An unexpected error occurred. Please try again later.");
        setOpenErrorDialog(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PushNotificationMgr
        displayState={allowPushNotificationDialogState}
        setDisplayState={setAllowPushNotificationDialogState}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openSuccessDialog} fullWidth maxWidth="xs">
        <DialogContent>
          <MDBox mt={3} align="center" mb={3}>
            <MDBox>
              <Box mt={1}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant="determinate"
                    size={120}
                    thickness={2}
                    color="success"
                    value={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color="success" fontSize="large">
                      check
                    </Icon>
                  </Box>
                </Box>
              </Box>
            </MDBox>
            <MDBox mt={2}>
              <MDTypography variant="h6" fontWeight="light">
                {statusMsg}
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSuccessDialog(false);
              window.location.reload();
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openErrorDialog} fullWidth maxWidth="xs">
        <DialogContent>
          <MDBox mt={3} align="center" mb={3}>
            <MDBox>
              <Box mt={1}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant="determinate"
                    size={120}
                    thickness={2}
                    color="error"
                    value={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color="error" fontSize="large">
                      close
                    </Icon>
                  </Box>
                </Box>
              </Box>
            </MDBox>
            <MDBox mt={2}>
              <MDTypography variant="h6" fontWeight="light">
                {statusMsg}
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenErrorDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>

      {sellResult && (
        <Dialog open fullWidth maxWidth="sm">
          <DialogContent>
            <Box p={1}>
              <Box align="center">
                <Box>
                  <MDTypography variant="h4" fontWeight="light">
                    {sellResult.caption}
                  </MDTypography>
                  <MDTypography mt={1} variant="h3" fontWeight="medium">
                    <small>{sellResult.currency}</small>
                    {(sellResult.debit_amount / 100).toLocaleString("en", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    {sellResult.debit_amount > sellResult.amount && (
                      <MDTypography fontSize={14} fontWeight="light">{`${
                        sellResult.currency
                      }${(sellResult.fee / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })} fee incl.`}</MDTypography>
                    )}
                  </MDTypography>
                </Box>
                {sellResult.type === "display" ? (
                  <Box>
                    <Box mt={1} align="center" mb={3}>
                      <Typography variant="h6" fontWeight="regular">
                        {sellResult.instructions}
                      </Typography>
                    </Box>
                    <Divider />
                    <Box mt={2} mb={2} align="center">
                      {sellResult.instrument.map((record) => (
                        <Grid container spacing={0}>
                          <Grid item xs={6} md={6} lg={6}>
                            <Box align="left">
                              <Typography
                                variant="h6"
                                fontWeight="light"
                                fontSize={18}
                              >
                                <b>{record.key}:</b>
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={6} md={6} lg={6}>
                            <Box align="right">
                              <Typography
                                variant="h6"
                                fontWeight="light"
                                fontSize={18}
                              >
                                {record.value}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      ))}
                    </Box>
                    <Divider />
                    <Box mt={3} align="center">
                      <Typography variant="h6" fontWeight="bold" color="error">
                        {sellResult.notes}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    <Box mt={2} align="center" mb={3}>
                      <Typography
                        variant="h6"
                        fontWeight="regular"
                        fontSize={17}
                      >
                        {sellResult.instructions}
                      </Typography>
                    </Box>
                    <Box>
                      <QRCode
                        value={
                          sellResult.instrument.redirect_url != null
                            ? sellResult.instrument.redirect_url
                            : ""
                        }
                        size={180}
                      />
                    </Box>
                    <Box mt={3}>
                      <MDButton
                        onClick={() => {
                          // window.location.href = sellResult.instrument.redirect_url;
                          window
                            .open(sellResult.instrument.redirect_url, "_blank")
                            .focus();
                        }}
                        color="success"
                        variant="contained"
                        startIcon={<Icon>payment</Icon>}
                      >
                        Pay Now
                      </MDButton>
                    </Box>
                  </Box>
                )}
                <Box mt={5}>
                  {showInlineLoading && (
                    <Box mb={3}>
                      <MDTypography mb={1} fontSize={12}>
                        Checking payment status...
                      </MDTypography>
                      <CircularProgress color="info" />
                    </Box>
                  )}
                  <MDButton
                    color="success"
                    variant="outlined"
                    sx={{ width: "100%" }}
                    onClick={() => {
                      checkPayment(sellResult.reference);
                    }}
                  >
                    Check Payment
                  </MDButton>

                  <Box
                    mt={3}
                    onClick={() => {
                      if (
                        window.confirm(
                          "Are you sure you want to cancel this transaction?",
                        ) === true
                      ) {
                        window.location.reload();
                      }
                    }}
                  >
                    <Typography variant="h6" fontWeight="light">
                      [ x cancel ]
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      {loadedCampaign && (
        <MDBox>
          <MDBox pt={3} pb={3}>
            <Grid
              container
              spacing={3}
              display="flex"
              alignItems="center"
              justifyContent="space-evenly"
            >
              <Grid item xs={12} md={7} lg={7}>
                <MDBox>
                  <MDBox mb={3}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2} align="center">
                        <MDTypography variant="h6" fontWeight="medium">
                          {loadedCampaign.title}
                        </MDTypography>
                        <MDBox mt={1}>
                          <MDTypography variant="body2" fontWeight="light">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: loadedCampaign.description,
                              }}
                            />
                          </MDTypography>
                        </MDBox>
                        {offlineLink && (
                          <MDBox mt={2}>
                            <MDButton
                              variant="contained"
                              size="small"
                              color="error"
                              startIcon={<Icon>wifi_off</Icon>}
                              onClick={() => {
                                window.open(offlineLink, "_blank");
                              }}
                            >
                              Offline Capture
                            </MDButton>
                          </MDBox>
                        )}
                      </MDBox>
                    </Card>
                  </MDBox>

                  {dataForm !== null && (
                    <MDBox mt={3}>
                      <DataFormComponent
                        ref={dataFormRef}
                        dataForm={dataForm}
                      />
                    </MDBox>
                  )}

                  {presetAmount !== null && (
                    <Box mt={3} mb={3}>
                      <Card sx={{ height: "100%", marginTop: "0px" }}>
                        <Box px={3} py={3}>
                          <Box>
                            <MDTypography variant="caption" fontWeight="bold">
                              PAYMENT INFORMATION
                            </MDTypography>
                            {presetAmount.amount_type === "FIXED" ? (
                              <Box mt={2} mb={3}>
                                <TextField
                                  name="Amount"
                                  margin="dense"
                                  label={presetAmount.display_name}
                                  readonly
                                  fullWidth
                                  variant="outlined"
                                  value={selectedAmount.toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        {presetAmount.currency}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Box>
                            ) : (
                              <Box mt={2} mb={3}>
                                <TextField
                                  name="Amount"
                                  margin="dense"
                                  label={presetAmount.display_name}
                                  placeholder="Enter an amount"
                                  type="decimal"
                                  fullWidth
                                  variant="outlined"
                                  onChange={(e) => {
                                    setAmount(e.target.value);
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        {presetAmount.currency}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <Box mt={0.5}>
                                  <Grid container spacing={3}>
                                    <Grid item xs={6} md={6} lg={6}>
                                      {presetAmount.minimum_amount !== null && (
                                        <Typography
                                          align="left"
                                          fontSize={10}
                                          px={1}
                                        >
                                          {`Minimum: ${presetAmount.currency}
                                      ${(
                                        presetAmount.minimum_amount / 100
                                      ).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}
                                        </Typography>
                                      )}
                                    </Grid>
                                    <Grid item xs={6} md={6} lg={6}>
                                      {presetAmount.maximum_amount !== null && (
                                        <Typography
                                          align="right"
                                          fontSize={10}
                                          px={1}
                                        >
                                          {`Maximum: ${presetAmount.currency}
                                      ${(
                                        presetAmount.maximum_amount / 100
                                      ).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}
                                        </Typography>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Box>
                            )}
                          </Box>
                          <Box mt={5} mb={3}>
                            <MDTypography variant="caption" fontWeight="bold">
                              PAYMENT METHOD
                            </MDTypography>
                            <Box mt={2}>
                              <FormControl
                                sx={{ minWidth: 120, width: "100%" }}
                              >
                                <InputLabel>How do you want to pay?</InputLabel>
                                <Select
                                  label="How do you want to pay?"
                                  onChange={(e) => {
                                    setPaymentMethod(e.target.value);
                                  }}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Icon>payment</Icon>
                                      </InputAdornment>
                                    ),
                                  }}
                                >
                                  {
                                    // --> Notice below changes
                                    presetAmount.payment_methods.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      presetAmount.payment_methods.map(
                                        (record) => (
                                          <MenuItem
                                            key={record.value}
                                            value={record.value}
                                          >
                                            {record.name}
                                          </MenuItem>
                                        ),
                                      )
                                  }
                                </Select>
                              </FormControl>
                            </Box>
                          </Box>
                        </Box>
                      </Card>
                    </Box>
                  )}

                  {dataForm && (
                    <MDBox>
                      <Card sx={{ height: "100%", marginTop: "0px" }}>
                        <MDBox mt={1} p={3}>
                          <MDButton
                            color="primary"
                            variant="contained"
                            sx={{ width: "100%" }}
                            onClick={() => {
                              capture();
                            }}
                          >
                            Submit
                          </MDButton>
                        </MDBox>
                      </Card>
                    </MDBox>
                  )}
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default DataCapturePage;
